import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Panel, ButtonGroup, Row, Col, Dropdown } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SaveButton from '../../components/buttons/saveButton/SaveButton'

export default function TableTrackingHistoryLaw({
  schema,
  pagination,
  loading,
  onReload = () => {},
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [tableData, setTableData] = useState([])
  const history = useHistory()

  // console.log('table schema ', schema)

  useEffect(() => {
    if (pagination && typeof onReload !== 'function') {
      setTableData(getData())
    } else if (schema.values) {
      setTableData(schema.values)
    } else {
      setTableData([])
    }
  }, [schema, pagination, onReload])

  const getData = () => {
    return schema?.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage page', dataKey)

    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  return (
    <>
      <Panel header={schema.header || 'แสดงรายการคดี'} shaded collapsible defaultExpanded bordered>
        {/* {schema.exportButton && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right' }}>
              <Dropdown
                title={schema.exportButton.label}
                appearance="primary"
                color="blue"
                icon={<Icon icon="file-text-o"></Icon>}
                placement="bottomEnd"
              >
                {schema.exportButton.options.map((item, index) => {
                  return <Dropdown.Item key={index}>{item.label}</Dropdown.Item>
                })}
              </Dropdown>
            </Col>
          </Row>
        )} */}

        <Table
          wordWrap
          minHeight={400}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
        >
          <Column width={70} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={100}>
            <HeaderCell>รหัสคดี</HeaderCell>
            <Cell dataKey="litigationCode" />
          </Column>

          <Column width={350} minWidth={350} flexGrow={1}>
            <HeaderCell>ชื่อคดี</HeaderCell>
            <Cell dataKey="litigationName" />
          </Column>

          <Column width={250}>
            <HeaderCell>เลขที่สัญญา/รหัสอ้างอิงอื่นๆ</HeaderCell>
            <Cell dataKey="referCodeDocument" />
          </Column>

          <Column width={180}>
            <HeaderCell>ประเภทคดี</HeaderCell>
            <Cell dataKey="lawType" />
          </Column>

          <Column width={190}>
            <HeaderCell>สถานะทางกฎหมาย</HeaderCell>
            <Cell dataKey="lawStatus" />
          </Column>

          <Column width={230}>
            <HeaderCell>สถานะย่อยทางกฎหมาย</HeaderCell>
            <Cell dataKey="lawSubStatus" />
          </Column>

          <Column width={150}>
            <HeaderCell>รหัสโครงการ</HeaderCell>
            <Cell dataKey="projectCode" />
          </Column>

          <Column width={350}>
            <HeaderCell>ชื่อโครงการ</HeaderCell>
            <Cell dataKey="projectName" />
          </Column>

          <Column width={225} align="center">
            <HeaderCell>วันครบกำหนดอายุความ</HeaderCell>
            <Cell>
              {(rowData) => {
                return <span>{rowData?.actionDate?.due}</span>
              }}
            </Cell>
          </Column>

          {/* <Column width={200} align="center">
            <HeaderCell>วันที่ดำเนินการล่าสุด</HeaderCell>
            <Cell>
              {(item, _) => {
                if (!item?.actionDate?.due) {
                  return item.actionDate
                }
                return (
                  <>
                    <Row>
                      <Col>{item.actionDate.date}</Col>
                      <Col style={{ color: 'red', fontSize: 12 }}>{`(ครบกำหนดอายุความ ${
                        item?.actionDate?.due || ''
                      })`}</Col>
                    </Row>
                  </>
                )
              }}
            </Cell>
          </Column> */}

          <Column width={150} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    <SaveButton icon="eye" onClick={() => onSelect(rowData)}>
                      ดูประวัติ
                    </SaveButton>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>

        {pagination && (
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={schema?.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}
      </Panel>
    </>
  )
}
